import {
  SR_API_ACTION_GET_TENANT_ALERT_REPORT,
} from 'api/actionTypes';

export default async function getTenantAlertReport({ state, apiClient }, { userId }) {
  const tenantAlertReportPath = ['household', 'tenantAlertReportByUserId', userId];

  if (state.exists(tenantAlertReportPath)) {
    return state.get(tenantAlertReportPath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_TENANT_ALERT_REPORT,
    state: state,
    payload: {
      userId,
    },
    onSuccess(tenantAlertReport) {
      state.set(tenantAlertReportPath, tenantAlertReport);
    },
  });
}
